const CHANGE_ROW_COUNT = 'CHANGE_ROW_COUNT';


const handleChangeRowCount = (rowCount) => ({
    type: CHANGE_ROW_COUNT,
    payload: {
      rowCount
    },
});

export {
    CHANGE_ROW_COUNT,
    handleChangeRowCount,
}
